<template>
    <div class="lb-project-content pb-6 has-scroll-y lb-treasurehunt-content">
        <div class="columns is-centered">
            <div class="column has-text-white is-narrow pt-3 mt-6">
                <!--div 
          v-for="item in items" 
          :key="item._id" 
          class="box">
          {{ item._id }}
          {{ item.order }}
                </div-->
                <div v-if="items.length">
                    <object-card-with-trigger
                        v-for="(object, _id, index) in path"
                        :key="_id"
                        :object="object"
                        :model="contentModel"
                        :triggers="triggers"
                        :modal-active="showInputModal"
                        :showObjectButtons="
                            index == Object.keys(path).length - 1
                        "
                        :resetPoint="resetPoint"
                        class="lb-treasurehunt-object"
                        @edit="editObject"
                        @delete="deleteObject(object)"
                        @deleteClue="deleteClue(object)"
                        @update="updateObject"
                        @updateClue="updateClue"
                        @addElement="openModal"
                        @add="insertObject({ ...$event, ...{ object } })"
                        @cancel="cancelCreation"
                        @cancel-edition-object="cancelEditionObject"
                        @cancel-edition-clue="cancelEditionClue"
                        @goalreseted="resetPoint = ''"
                    />
                </div>
                <div
                    v-if="!creationEnabled && canAddNewObject"
                    class="has-text-centered pt-6 pb-6"
                    @click.stop
                >
                    <div
                        v-for="option in availableObjectsForTrigger(lastItem)"
                        :key="option"
                        class
                    >
                        <button
                            class="button is-primary is-active"
                            @click="
                                insertObject({
                                    object: lastItem,
                                    type: option,
                                })
                            "
                        >
                            {{ $t(`App.${option}`) }}
                        </button>
                    </div>
                    <!--<div class="dropdown is-hoverable">
                        <div class="dropdown-trigger">
                            <button
                                class="button"
                                aria-haspopup="true"
                                aria-controls="dropdown-menu4"
                            >
                                <span class="icon" aria-hidden="true">
                                    <i class="fas fa-plus"></i>
                                </span>
                            </button>
                        </div>
                        <div class="dropdown-menu" role="menu">
                            <div class="dropdown-content">
                                <a
                                    v-for="option in availableObjectsForTrigger(
                                        lastItem
                                    )"
                                    :key="option"
                                    class="dropdown-item"
                                    @click="
                                        insertObject({
                                            object: lastItem,
                                            type: option,
                                        })
                                    "
                                >{{ $t(`App.${option}`) }}</a>
                            </div>
                        </div>
                    </div>-->
                </div>

                <input-modal
                    v-if="showInputModal"
                    v-model="activeDraft[contentProperty]"
                    :active.sync="showInputModal"
                    :component-type="componentType"
                    @input="showInputModal = false"
                    @click.stop
                    @cancel="showInputModal = false"
                />
            </div>
            <!--project-content-toolbar :options="availableObjectsForTrigger(lastItem)" /-->
        </div>
    </div>
</template>

<script>
import ObjectCardWithTrigger from '@/components/ObjectCardWithTrigger';
import InputModal from '@/components/InputModal';
import { getShortestPaths } from '@xstate/graph';
import { createMachine } from 'xstate';
import _ from 'underscore';
import { availableTriggers, availableObjects } from '@labygram/treasurehunt';

export default {
    components: {
        ObjectCardWithTrigger,
        InputModal,
    },
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            componentType: undefined,
            showInputModal: false,
            activeDraft: {},
            selectedTrigger: undefined,
            selectedModel: undefined,
            originalItem: {},
            originalGoal: {},
            resetPoint: '',
        };
    },
    computed: {
        contentModel() {
            if (!this.selectedModel) {
                return this.$store.getters[`objectModel`];
            }
            // console.log('finding', this.selectedModel + 'Model');
            return this.$store.getters[`${this.selectedModel}Model`];
        },
        availableObjectTypes() {
            if (!this.items.length) {
                return ['object', 'question'];
            } else {
                return ['object', 'question', 'point'];
            }
        },
        draftDefaults() {
            // console.log('draftDefaults', this.contentModel);
            return {
                _id: 'draft',
                type: this.contentModel.type,
                order: this.items.length,
                triggers: { [this.triggers[0]]: '' },
                owner: this.$store.getters.user.owner,
            };
        },
        lastItem() {
            return this.items.length ? this.path[_.last(this.shortPath)] : null;
        },
        triggers() {
            return availableTriggers(this.lastItem, this.activeDraft);
        },
        canAddNewObject() {
            if (this.items.length) {
                return false;
            }
            if (!this.lastItem) {
                return true;
            }
            return !_.contains(_.keys(this.lastItem.triggers), 'END');
        },
        states() {
            const _states = {};
            this.items.forEach((item) => {
                _states[item._id] = {
                    on: item.triggers,
                };
                if (!item.triggers) {
                    _states[item._id].type = 'final';
                }
            });
            return _states;
        },
        shortPath() {
            return _.map(getShortestPaths(this.machine), (node) => {
                return node.state.value;
            });
        },
        path() {
            let path = {};
            _.each(this.shortPath, (_id) => {
                path[_id] = this.findModel({ _id });
            });
            return path;
        },
        machine() {
            const initialItem = _.sortBy(this.items, (item) => {
                return item.order;
            })[0];
            return createMachine({
                id: 'machine',
                initial: initialItem._id,
                states: this.states,
            });
        },
        creationEnabled() {
            return this.$store.getters['Project/creationEnabled'];
        },
        contentProperty() {
            switch (this.componentType) {
                case 'image': {
                    return 'images';
                }
                case 'answer': {
                    return 'answers';
                }
                default:
                    return this.componentType;
            }
        },
    },
    watch: {
        'activeDraft.answers'() {
            //if object becomes a question, we need to force change the default trigger in dropdown, but only if it is a brand new object, not an edition.
            if (_.isEmpty(_.pick(this.activeDraft.triggers, Boolean))) {
                this.activeDraft.triggers = { [this.triggers[0]]: '' };
            }
        },
    },
    methods: {
        availableObjectsForTrigger(object) {
            return availableObjects(object);
        },
        findModel(params) {
            return _.findWhere(this.items, params);
        },
        openModal(e) {
            this.showInputModal = true;
            this.componentType = e.type;
        },
        enableCreation() {
            // console.log('enableCreation');
            this.activeDraft = this.draftDefaults;
            // console.log('enableCreation', this.activeDraft);
            this.$store.dispatch('Project/enableCreation');
        },
        addNewObject(model) {
            this.selectedModel = model;
            this.enableCreation();
        },
        addObjectFromDraggable({ item }) {
            this.selectedModel = item.dataset.mediatype;
            this.enableCreation();
        },
        editObject(object) {
            this.selectedModel = object.type;
            this.activeDraft = object;
            if (this.activeDraft.type != 'point' && this.activeDraft.type) {
                // console.log('editing from object');
                this.originalItem = JSON.parse(JSON.stringify(object));
                //console.log('editing', this.originalItem);
                if (this.originalItem.triggers.GO_TO_POINT) {
                    // console.log('finding goal');
                    this.originalGoal = JSON.parse(
                        JSON.stringify(
                            this.$store.getters.projectContent.filter(
                                (item) => {
                                    return (
                                        item._id ==
                                        this.originalItem.triggers.GO_TO_POINT
                                    );
                                }
                            )[0]
                        )
                    );
                }
            }
            // console.log('edit item ', this.originalItem, this.originalGoal);
        },
        async updateObject(object) {
            this.$store.dispatch('Project/disableCreation');
            if (object._id == 'draft' || !object._id) {
                // delete object._id; not doing this allows machine to be recreated dynamically
                const result = await this.$store.dispatch('createObject', {
                    ...object,
                    ...{ project: this.$route.params.projectId },
                });

                // remove draft object
                const draftIndex = _.findIndex(
                    this.$store.getters.projectContent,
                    {
                        _id: 'draft',
                    }
                );
                if (-1 !== draftIndex) {
                    this.$store.state.projectContent.splice(draftIndex, 1);
                }
                // end of remove draft object

                const parent = this.findModel({ order: result.order - 1 });
                if (parent) {
                    const trigger = _.keys(parent.triggers)[0];
                    parent.triggers[trigger] = result._id;
                    await this.$store.dispatch('updateObject', {
                        ...parent,
                    });
                }
                const child = this.findModel({ order: result.order + 1 });
                if (child) {
                    this.updateOrderItems(result._id, 1, result.order);
                }
            } else {
                await this.$store.dispatch('updateObject', {
                    ...object,
                });
            }

            this.activeDraft = { ...this.draftDefaults };
            this.originalItem = {};
            this.originalGoal = {};
        },
        async updateClue(clue, point) {
            // console.log('try to save clue/point', clue, point);
            this.$store.dispatch('Project/disableCreation');

            if (clue._id == 'draft' || !clue._id) {
                // console.log('new clue / point');
                if (clue._id == 'draft' || !clue._id) {
                    // console.log('saving clue');
                    //clue.triggers = { GO_TO_POINT: '' };
                    clue.type = 'object';
                    await this.$store
                        .dispatch('createObject', {
                            ...clue,
                            ...{ project: this.$route.params.projectId },
                        })
                        .then((clueResult) => {
                            // console.log('clue saved', clueResult);
                            console.log('saving point');
                            /*const parent = this.findModel({
                                order: clueResult.order - 1,
                            });
                            if (parent) {
                                const trigger = _.keys(parent.triggers)[0];
                                point.triggers = {
                                    AT_ARRIVE: parent.triggers[trigger],
                                };
                            } else {
                                point.triggers = { AT_ARRIVE: '' };
                            }*/
                            point.triggers = {
                                AT_ARRIVE: clueResult.triggers.GO_TO_POINT,
                            };
                            point.type = 'point';
                            point.order = clueResult.order + 1;
                            this.$store
                                .dispatch('createObject', {
                                    ...point,
                                    ...{
                                        project: this.$route.params.projectId,
                                    },
                                })
                                .then((pointResult) => {
                                    // remove draft object
                                    // console.log('remove draft object');
                                    const draftIndex = _.findIndex(
                                        this.$store.getters.projectContent,
                                        {
                                            _id: 'draft',
                                        }
                                    );
                                    if (-1 !== draftIndex) {
                                        this.$store.state.projectContent.splice(
                                            draftIndex,
                                            1
                                        );
                                    }
                                    // console.log(' draft object removed');
                                    // end of remove draft object

                                    // console.log('finding clue parent');
                                    const parent = this.findModel({
                                        order: clueResult.order - 1,
                                    });
                                    if (parent) {
                                        const trigger = _.keys(
                                            parent.triggers
                                        )[0];
                                        parent.triggers[trigger] =
                                            clueResult._id;
                                        // console.log('updating parent');
                                        this.$store.dispatch('updateObject', {
                                            ...parent,
                                        });
                                        // console.log('clue parent updated');
                                    }

                                    const clueTrigger = _.keys(
                                        clueResult.triggers
                                    )[0];
                                    clueResult.triggers[clueTrigger] =
                                        pointResult._id;
                                    // console.log('adding point to clue');
                                    this.$store.dispatch('updateObject', {
                                        ...clueResult,
                                    });
                                    // console.log('clue point added');
                                    const child = this.findModel({
                                        order: clueResult.order + 1,
                                    });
                                    if (child) {
                                        this.updateOrderItems(
                                            pointResult._id,
                                            2,
                                            clueResult.order,
                                            clueResult._id
                                        );
                                    }
                                });
                        });
                }
            } else {
                // console.log('updating clue/point', clue, point);
                await this.$store.dispatch('updateObject', {
                    ...clue,
                });
                await this.$store.dispatch('updateObject', {
                    ...point,
                });
            }
            // console.log('clue/point created or updated');
            this.activeDraft = { ...this.draftDefaults };
            this.originalItem = {};
            this.originalGoal = {};
        },
        cancelCreation() {
            // console.log('in cancel creation');
            this.$store.dispatch('Project/disableCreation');
            this.removeDraft();
        },
        cancelEditionObject() {
            // console.log('cancel object edition');
            this.$store.dispatch('Project/disableCreation');
            const objectIndex = _.findIndex(this.items, {
                _id: this.originalItem._id,
            });
            this.items.splice(objectIndex, 1, this.originalItem);

            this.activeDraft = { ...this.draftDefaults };
            this.originalItem = {};
            this.originalGoal = {};
        },
        cancelEditionClue() {
            // console.log('cancel clue/point edition');
            this.$store.dispatch('Project/disableCreation');
            const objectIndex = _.findIndex(this.items, {
                _id: this.originalItem._id,
            });
            this.items.splice(objectIndex, 1, this.originalItem);

            const goalIndex = _.findIndex(this.items, {
                _id: this.originalGoal._id,
            });
            this.items.splice(goalIndex, 1, this.originalGoal);
            this.resetPoint = this.originalGoal._id;

            this.activeDraft = { ...this.draftDefaults };
            this.originalItem = {};
            this.originalGoal = {};
        },
        insertObject({ object, trigger, type }) {
            // console.log('in insert object', object, trigger, type);
            this.selectedModel = type;
            // console.log('type', type);
            this.enableCreation();
            // console.log('creation enabled for', this.selectedModel);

            if (!object) {
                console.log('inserting first object', this.activeDraft);
                return this.$store.commit(
                    'ADD_OBJECT_TO_PROJECT',
                    this.activeDraft
                );
            }
            /*if (trigger) {
                this.selectedTrigger = trigger;
            } else {
                this.selectedTrigger = _.keys(object.triggers)[0];
            }*/
            let previousObject = JSON.parse(JSON.stringify(object));
            this.selectedTrigger = _.keys(previousObject.triggers)[0];
            // console.log('selected trigger', this.selectedTrigger);
            /*console.log(
                'original object trigger value',
                object.triggers[this.selectedTrigger]
            );*/
            let objectTriggerValue = '';
            if (previousObject.triggers[this.selectedTrigger].length) {
                objectTriggerValue = JSON.parse(
                    JSON.stringify(
                        previousObject.triggers[this.selectedTrigger]
                    )
                );
            }

            // console.log('object trigger value', objectTriggerValue);
            // console.log('object trigger value', objectTriggerValue);
            this.activeDraft.order = previousObject.order + 1;
            const values = _.values(previousObject.triggers);
            if (_.chain(values).compact().isEmpty()) {
                const keys = availableTriggers(
                    previousObject,
                    this.activeDraft
                );
                if (this.activeDraft.type == 'clue') {
                    this.activeDraft.triggers = {
                        ['GO_TO_POINT']: objectTriggerValue,
                    };
                } else {
                    // console.log('assigning empty trigger value to draft');
                    this.activeDraft.triggers = {
                        [keys[0]]: objectTriggerValue,
                    };
                }

                //_.object(keys, values);
            } else {
                /* this.activeDraft.triggers = JSON.parse(
                    JSON.stringify(object.triggers)
                ); //deep copy*/
                /*console.log(
                    'assigning object trigger value to draft',
                    objectTriggerValue
                );*/
                this.activeDraft.triggers = { [keys[0]]: objectTriggerValue };
            }
            // console.log('selected trigger', this.selectedTrigger);
            object.triggers[this.selectedTrigger] = this.activeDraft._id;

            // console.log('activeDraft', this.activeDraft);
            /*if (
                this.activeDraft.order <
                this.$store.getters.projectContent.length
            ) {
                console.log(
                    'inserting object between existing objects',
                    this.activeDraft.order,
                    this.$store.getters.projectContent.length
                );
                console.log(object.triggers, this.activeDraft.triggers);
            }*/

            this.$store.commit('ADD_OBJECT_TO_PROJECT', this.activeDraft);
        },
        removeDraft() {
            if (!this.activeDraft._id) {
                let draftToRemove = _.find(this.items, (item) => {
                    return item._id === 'draft';
                });
                this.activeDraft = draftToRemove;
            }
            const parent = _.find(this.items, (item) => {
                return _.find(item.triggers, (trigger) => {
                    return trigger == this.activeDraft._id;
                });
            });
            if (this.activeDraft.triggers.GO_TO_POINT) {
                if (parent) {
                    const trigger = _.keys(parent.triggers)[0];
                    if (this.activeDraft.triggers.GO_TO_POINT.length) {
                        const goal = {
                            ...this.items.filter((item) => {
                                return (
                                    item._id ==
                                    this.activeDraft.triggers.GO_TO_POINT
                                );
                            })[0],
                        };
                        parent.triggers[trigger] = goal.triggers.AT_ARRIVE;
                    } else {
                        parent.triggers[trigger] = '';
                    }
                }
            } else {
                if (parent) {
                    const parentTrigger = _.keys(parent.triggers)[0];
                    /*console.log(
                        'parent trigger',
                        parentTrigger,
                        parent.triggers[parentTrigger]
                    );*/
                    const draftTrigger = _.keys(this.activeDraft.triggers)[0];
                    /*console.log(
                        'draft triggers',
                        draftTrigger,
                        this.activeDraft.triggers[draftTrigger]
                    );*/
                    parent.triggers[parentTrigger] =
                        this.activeDraft.triggers[draftTrigger];
                }
            }

            this.$store.commit(
                'REMOVE_OBJECT_FROM_PROJECT',
                this.activeDraft._id
            );

            this.activeDraft = { ...this.draftDefaults };
        },
        async deleteObject(object) {
            // console.log('try to remove object', object);
            const parent = _.find(this.items, (item) => {
                return _.find(item.triggers, (trigger) => {
                    return trigger == object._id;
                });
            });
            if (!parent) {
                alert(this.$t('delete_first_object_forbidden'));
                return;
            }
            if (!object._id || object._id == 'draft') {
                this.$store.dispatch('Project/disableCreation');
                this.removeDraft();
            } else if (
                confirm(this.$t('delete_project_confirmation_message'))
            ) {
                if (parent) {
                    // console.log('parent', parent);
                    const parentTrigger = _.keys(parent.triggers)[0];
                    const objectTrigger = _.keys(object.triggers)[0];
                    /*console.log(
                        'parent trigger',
                        parentTrigger,
                        parent.triggers[parentTrigger]
                    );*/
                    /*console.log(
                        'object trigger',
                        objectTrigger,
                        object.triggers[objectTrigger]
                    );*/
                    const objectTriggerValue = JSON.parse(
                        JSON.stringify(object.triggers[objectTrigger])
                    );
                    // console.log('trigger value to assign', objectTriggerValue);
                    parent.triggers[parentTrigger] = objectTriggerValue;

                    await this.$store
                        .dispatch('updateObject', {
                            ...parent,
                        })
                        .then(() => {
                            this.$store
                                .dispatch('deleteObject', object._id)
                                .then(() => {
                                    // console.log('object deleted');
                                    if (objectTriggerValue.length) {
                                        // console.log('reordering items.');
                                        this.reorderItems(
                                            objectTriggerValue,
                                            1
                                        );
                                    } else {
                                        console.log('finished process.');
                                    }
                                });
                        });
                }
            }
        },
        async deleteClue(object) {
            // console.log('try to delete clue', object);
            if (!object._id || object._id == 'draft') {
                this.$store.dispatch('Project/disableCreation');
                this.removeDraft();
            } else if (
                confirm(this.$t('delete_project_confirmation_message'))
            ) {
                const clue = { ...object };
                const parent = _.find(this.items, (item) => {
                    return _.find(item.triggers, (trigger) => {
                        return trigger == object._id;
                    });
                });

                const goal = {
                    ...this.items.filter((item) => {
                        return item._id == clue.triggers.GO_TO_POINT;
                    })[0],
                };
                // console.log(clue, parent, goal);

                if (parent) {
                    // find clue point
                    const trigger = _.keys(parent.triggers)[0];
                    if (goal) {
                        parent.triggers[trigger] = goal.triggers.AT_ARRIVE;
                    } else {
                        //TODO: check for child objects throug his position
                        parent.triggers[trigger] = '';
                    }
                    /*await this.$store.dispatch('updateObject', {
                        ...parent,
                    });*/
                    await this.$store
                        .dispatch('updateObject', {
                            ...parent,
                        })
                        .then(() => {
                            if (goal) {
                                this.$store.dispatch('deleteObject', goal._id);
                                // console.log('goal deleted');
                            }
                            this.$store
                                .dispatch('deleteObject', clue._id)
                                .then(() => {
                                    // console.log('clue deleted');
                                    if (goal) {
                                        if (goal.triggers.AT_ARRIVE.length) {
                                            // console.log('reordering items.');
                                            this.reorderItems(
                                                goal.triggers.AT_ARRIVE,
                                                2
                                            );
                                        }
                                    }
                                    console.log('finished process.');
                                });
                        });
                }
            }
        },
        focusDraft() {
            this.$nextTick(() => {
                if (this.$refs.draft && this.$refs.draft.length) {
                    this.$refs.draft[0].scrollIntoView({
                        block: 'end',
                        inline: 'nearest',
                    });
                }
            });
        },
        async reorderItems(objectId, index) {
            // used when remove an object
            // console.log('finding index for object id', objectId);
            const objectsInGame = JSON.parse(
                JSON.stringify(
                    _.sortBy(this.$store.getters.projectContent, (item) => {
                        return item.order;
                    })
                )
            );

            // console.log(objectsInGame);
            const objectIndex = _.findIndex(objectsInGame, {
                _id: objectId,
            });
            // console.log('object located at', objectIndex);

            const objectsToUpdate = objectsInGame.splice(
                objectIndex,
                objectsInGame.length
            );
            // console.log('objects to update order value', objectsToUpdate);

            for (let objectToUpdate of objectsToUpdate) {
                objectToUpdate.order = objectToUpdate.order - index;
                await this.$store.dispatch('updateObject', {
                    ...objectToUpdate,
                });
            }
        },
        async updateOrderItems(objectId, index, objectOrder, clueId) {
            // used when inserting an item between existent objets
            // console.log('finding index for object id', objectId);
            const objectsInGame = JSON.parse(
                JSON.stringify(
                    _.sortBy(this.$store.getters.projectContent, (item) => {
                        return item.order;
                    })
                )
            );

            for (let objectToUpdate of objectsInGame) {
                if (
                    objectToUpdate._id != objectId &&
                    objectToUpdate.order >= objectOrder &&
                    objectToUpdate._id != clueId
                ) {
                    objectToUpdate.order = objectToUpdate.order + index;
                    await this.$store.dispatch('updateObject', {
                        ...objectToUpdate,
                    });
                }
            }
        },
    },
    mounted() {
        setTimeout(() => {
            if (
                !this.enableCreation() &&
                this.canAddNewObject &&
                !this.items.length
            ) {
                console.log('inserting first object');

                this.insertObject({ object: this.lastItem, type: 'object' });
            }
        }, 500);
    },
};
</script>

<style scoped>
.lb-treasurehunt-content {
    min-height: calc(100vh - 9rem);
}
</style>
